module.exports = __webpack_public_path__ + "img/play.ce7297c0.png";